export const selectAllProductsFromCart = (state) => state.productsReducer.cart;
